import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

//ACTIONS
import * as GlobalVarsActions from "../../../../../../../store/actions/globalVars";

//STYLES
import * as ApproveBookingsStyles from "../styles/approveBookings";

//COMPONENTS
import ApproveBookingItem from "./approveBookingItem";

function ApproveBookings() {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const user = useSelector((state) => state.user);

    const [bookings, setBookings] = useState([]);
    const [questions, setQuestions] = useState([]);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "Yes",
        showAccept: false,
        cancelName: "No",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        if (user.bookingApprove != "true") {
            navigate("/");
        } else {
            dispatch(GlobalVarsActions.UpdateMenuID("items", "approveBookings"));
            onLoad();
        }
    }, []);

    function onLoad() {
        const data = { orgID: params.orgID, userID: user.uuid };
        Axios.post("/bookings/getPendingBookings", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    // console.log(data);
                    setQuestions(data.bookingQuestions);

                    for (const booking of data.bookings) {
                        console.log(booking);
                        if (booking.pendingCollides != "") {
                            const collides = booking.pendingCollides.split(",");
                            const otherBookings = [];
                            for (const col of collides) {
                                const b = data.bookings.find((book) => book.uuid == col);
                                if (b != null) {
                                    otherBookings.push(b);
                                }
                                b.show = false;
                            }
                            booking.otherBookings = otherBookings;
                            booking.show = true;
                        } else {
                            if (booking.show == null) {
                                booking.show = true;
                            }
                        }
                    }
                    console.log(data.bookings);
                    setBookings(data.bookings);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleEditApprovalStatus(bookingUUID, bookingLinks, status) {
        if (status == "approved" && bookingLinks.length > 1) {
            setModalYN((prevState) => {
                return {
                    ...prevState,
                    heading: "Accept this booking?",
                    message: "Accepting this booking will deny the other bookings, do you want to continue?",
                    showAccept: true,
                    acceptName: "Yes",
                    acceptFunction: handleAcceptChange.bind(this, bookingUUID, bookingLinks, status),
                    showCancel: true,
                    open: true
                };
            });
        } else {
            handleAcceptChange(bookingUUID, bookingLinks, status);
        }
    }

    function handleAcceptChange(bookingUUID, bookingLinks, status) {
        const data = { orgID: params.orgID, bookingUUID: bookingUUID, bookingLinks: bookingLinks, status: status };
        Axios.post("/bookings/updateApprovalStatus", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModalYN((prevState) => {
                        return {
                            ...prevState,
                            open: false
                        };
                    });
                    onLoad();
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={ApproveBookingsStyles.body}>
            <h1 style={ApproveBookingsStyles.heading}>Approve Bookings</h1>
            <br />
            <Card>
                <Card.Body>
                    <Row>
                        <Col>User</Col>
                        <Col>Department</Col>
                        <Col>Room</Col>
                        <Col>Date</Col>
                        <Col>Session</Col>
                        <Col>Class</Col>
                        <Col style={ApproveBookingsStyles.buttonsContainer}>
                            <Button>
                                <i className="fa-solid fa-check"></i>
                            </Button>
                            <Button>
                                <i className="fa-solid fa-xmark"></i>
                            </Button>
                            <Button>
                                <i className="fa-solid fa-circle-question"></i>
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br />
            {bookings.map((booking, index) => {
                if (booking.show) {
                    return <LayoutItem key={index} booking={booking} handleEditApprovalStatus={handleEditApprovalStatus} questions={questions} />;
                }
            })}

            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

function LayoutItem(props) {
    const [bookingLinks, setBookingLinks] = useState([]);

    useEffect(() => {
        const bookingLinks = [];

        bookingLinks.push(props.booking.uuid);

        if (props.booking.otherBookings != null) {
            for (const other of props.booking.otherBookings) {
                bookingLinks.push(other.uuid);
            }
        }

        setBookingLinks(bookingLinks);
    }, [props]);
    return (
        <div>
            <ApproveBookingItem
                booking={props.booking}
                editApprovalStatus={props.handleEditApprovalStatus}
                questions={props.questions}
                bookingLinks={bookingLinks}
            />
            {props.booking.otherBookings != null && (
                <div>
                    {props.booking.otherBookings.map((book, index) => {
                        return (
                            <ApproveBookingItem
                                key={index}
                                booking={book}
                                editApprovalStatus={props.handleEditApprovalStatus}
                                questions={props.questions}
                                bookingLinks={bookingLinks}
                            />
                        );
                    })}
                </div>
            )}
            <br />
        </div>
    );
}

export default ApproveBookings;
